import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';

import { Slider as TWSlider } from 'twyne-new.ui';

class Slider extends React.Component {
  render () {
    const { setValue, getValue, min, max, step, name, className = '' } = this.props;

    return (
      <TWSlider
        name={name}
        onChange={value => setValue(value)}
        min={min}
        max={max}
        step={step}
        value={getValue()}
        className={className}
      />
    );
  }
}

Slider.propTypes = {
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  name: PropTypes.string
}

export default withFormsy(Slider);
